import { FlagsmithFlags } from '@utils/flagsmith';

export const isImprovedSalesTaxEnabled = (featureFlags: Set<FlagsmithFlags>) =>
  featureFlags.has(FlagsmithFlags.use_improved_sales_tax);
